import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
    selector: C.EWIZ_CONFIGURE_ADMIN_AGENT,
    templateUrl: "./configure-admin-agent.component.html",
    standalone: false
})
export class EWizConfigureAdminAgentComponent extends EWizDynamicBaseClassComponent {}
